import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'home', component: () => import('./views/Home.vue') },
  { path: '/pricing', name: 'pricing', component: () => import('./views/Pricing.vue') },
  { path: '/roadmap', name: 'roadmap', component: () => import('./views/Roadmap.vue') },
  { path: '/status', name: 'status', component: () => import('./views/Status.vue') },
  { path: '/privacy', name: 'privacy', component: () => import('./views/Privacy.vue') },
  { path: '/trust', name: 'trust', component: () => import('./views/Trust.vue') },
  { path: '/terms', name: 'terms', component: () => import('./views/Terms.vue') },
  { path: '/sign-in', name: 'sign-in', component: () => import('./views/SignIn.vue') },
  { path: '/auth/conflict', name: 'auth-conflict', component: () => import('./views/AuthConflict.vue') },
]

export { routes }

export function createAppRouter() {
  return createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition
      if (to.hash) return { el: to.hash, behavior: 'smooth' }
      return { top: 0 }
    },
  })
}
